export enum EpisodeStatusEnum{
    Iniciado = 1,
    Adiado = 2,
    FinalizadoAlta = 3,
    FinalizadoObito = 4,
    FinalizadoInternar = 5,
    FinalizadoEvasao = 6,
    FinalizadoAltaAdministrativa = 7,
    FinalizadoTransferir = 8,
}